import _ from "lodash";

window.heroCountdown = () => {
  return {
    items: [],
    currentTalks: [],
    isBefore: false,
    isAfter: false,
    firstDate: null,
    nextDate: null,
    lastDate: null,
    remaining: null,
    i18n: {
      title: {
        greeting: null,
        beforeWithTest: null,
        beforeWithoutTest: null,
        live: null,
        after: null,
      },
      text: {
        before: null,
        live: null,
        after: null,
      },
    },

    init() {
      this._setFirstDate();
      this._setLastDate();
      this._setNextDate();
      this._setState();
      this._setRemaining();
      this._setCurrentTalks();

      if (!this.isAfter) {
        setInterval(() => {
          this._setNextDate();
          this._setState();
          this._setRemaining();
          this._setCurrentTalks();
        }, 1000);
      }
    },

    _setState() {
      const now = new Date();

      if (this.firstDate !== null) {
        this.isBefore = this.firstDate >= now;
      }
      if (this.lastDate !== null) {
        this.isAfter = this.lastDate <= now;
      }
    },

    _setFirstDate() {
      if (this.items.length > 0) {
        this.firstDate = new Date(_.head(this.items).startDate * 1000);
      }
    },

    _setLastDate() {
      if (this.items.length > 0) {
        this.lastDate = new Date(_.last(this.items).endDate * 1000);
      }
    },

    _setNextDate() {
      const now = new Date();
      let closest = Infinity;

      this.items.forEach((d) => {
        const date = new Date(d.startDate * 1000);

        if (date >= now && (date < new Date(closest) || date < closest)) {
          closest = d;
        }
      });

      this.nextDate = new Date(closest.startDate * 1000);
    },

    _setCurrentTalks() {
      const now = Math.floor(Date.now() / 1000);
      this.currentTalks = [];
      this.items.forEach((slot) => {
        if (slot.startDate <= now && slot.endDate > now) {
          this.currentTalks = slot.talks;
        }
      });
    },

    _setRemaining() {
      if (this.items.length > 0) {
        const secondsUntil = this.nextDate - new Date();
        if (secondsUntil) {
          this.remaining = Math.floor(secondsUntil / 1000);
        }
      }
    },

    _format(value) {
      return parseInt(value);
    },

    month() {
      return {
        value: this.remaining / 86400,
        remaining: this.remaining % 86400,
      };
    },

    days() {
      return {
        value: this.remaining / 86400,
        remaining: this.remaining % 86400,
      };
    },

    hours() {
      return {
        value: this.days().remaining / 3600,
        remaining: this.days().remaining % 3600,
      };
    },

    minutes() {
      return {
        value: this.hours().remaining / 60,
        remaining: this.hours().remaining % 60,
      };
    },

    seconds() {
      return {
        value: this.minutes().remaining,
      };
    },

    get time() {
      return {
        days: this._format(this.days().value),
        hours: this._format(this.hours().value),
        minutes: this._format(this.minutes().value),
        seconds: this._format(this.seconds().value),
      };
    },

    title: {
      ["x-html"]() {
        if (this.isBefore && !this.isAfter) {
          if (this.$store.pt.name) {
            return `<mark>${this.i18n.title.greeting} ${this.$store.pt.name}</mark><br />${this.i18n.title.beforeWithTest}`;
          }
          return this.i18n.title.beforeWithoutTest;
        } else if (!this.isBefore && !this.isAfter && this.remaining) {
          if (this.$store.pt.name) {
            return `<mark>${this.i18n.title.greeting} ${this.$store.pt.name}</mark><br />${this.i18n.title.live}`;
          }
          return this.i18n.title.live;
        }

        if (this.$store.pt.name) {
          return `<mark>${this.i18n.title.greeting} ${this.$store.pt.name}</mark><br />${this.i18n.title.after}`;
        }
        return this.i18n.title.after;
      },
    },

    get text() {
      if (this.isBefore && !this.isAfter) {
        return this.i18n.text.before;
      }
      if (!this.isBefore && !this.isAfter && this.remaining) {
        return this.i18n.text.live;
      }
      return this.i18n.text.after;
    },
  };
};
